// DS: i3.9
import React from 'react';
import IconWrap, { Props } from '../../IconWrap';

const Upload: React.FC<Props> = props => {
  return (
    <IconWrap {...props}>
      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 32" role={props.role}>
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M21.26 24a1 1 0 0 0 1-1v-7.74h3.99a1 1 0 0 0 .65-1.75L16.22 4.24a1 1 0 0 0-1.34.03l-9.81 9.26a1 1 0 0 0 .68 1.73h3.27V23a1 1 0 0 0 1 1h11.24Zm-1-9.74V22h-9.24v-7.74a1 1 0 0 0-1-1H8.3l7.3-6.92 7.98 6.92h-2.3a1 1 0 0 0-1 1ZM8.76 26a1 1 0 1 0 0 2h14a1 1 0 1 0 0-2h-14Z"
        />
      </svg>
    </IconWrap>
  );
};
Upload.displayName = 'Upload';

export default Upload;
